module.exports = __webpack_public_path__ + "img/texture-bg.a77adaa9.png";